import React, {createContext} from "react";import Demand from "../../../../shared/entities/Demand";
;
import { DemandWithTotalPaid } from "../../../../shared/types/DemandWithTotalPaid";

const DemandContext = createContext<DemandWithTotalPaid>({...new Demand(), totalPaid: 0});

export default DemandContext;